import Vue from 'vue';
Vue.filter('formatPercentage', function (value) {
  if (!value) return '';
  return "".concat(value, " %");
});